module.exports = __webpack_public_path__ + "static/media/TableTopAssignTableScreen.1595b7cf.png";